<template>
  <SingleColumn>
    <template #header>
      <section class="sm:flex sm:items-center sm:justify-between">
        <div class="sm:flex sm:space-x-5">
          <h1 class="text-3xl font-bold text-white">
            Alle Einstellungen
          </h1>
        </div>
      </section>
    </template>
    <template #content>
      <MenuPanel v-if="data">
        <template #items>
          <MenuPanelItem icon="MicrophoneIcon" :to="{name: 'podcast.edit.general'}">
            Podcast
          </MenuPanelItem>
          <MenuPanelItem icon="StarIcon" :to="{name: 'podcast.edit.objective'}">
            Wachstumsziele
          </MenuPanelItem>
          <MenuPanelItem icon="AdjustmentsVerticalIcon" :to="{name: 'podcast.edit.stage'}">
            Empfehlungen
          </MenuPanelItem>
          <MenuPanelItem icon="LightBulbIcon" :to="{name: 'podcast.edit.strategy'}">
            Strategie
          </MenuPanelItem>
          <MenuPanelItem icon="ArrowUpRightIcon" :to="{name: 'podcast.edit.metrics'}">
            Erfolgskriterien
          </MenuPanelItem>
          <MenuPanelItem icon="FlagIcon" :to="{name: 'podcast.edit.milestones'}">
            Meilensteine
          </MenuPanelItem>
          <MenuPanelItem icon="UsersIcon" :to="{name: 'podcast.edit.coworkers'}">
            Coworker*innen
          </MenuPanelItem>
          <MenuPanelItem icon="SquaresPlusSolidIcon" :to="{name: 'podcast.edit.contract'}">
            Studio Upgrade
          </MenuPanelItem>
        </template>
        <template #main>
          <router-view>
          </router-view>
        </template>
      </MenuPanel>
    </template>
  </SingleColumn>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const data = computed(() => store.getters['auth/user']);


</script>
